import tw from 'twin.macro'

/** Without preflight, native inputs keep inset borders — only top/left appear visible. */
export const flowEditorFieldBorderCss = tw`box-border rounded-lg border border-solid border-shades-200 outline-none focus:border-primary-400`

export const flowEditorTextInputCss = [
  flowEditorFieldBorderCss,
  tw`h-[38px] min-w-0 flex-1 bg-shades-0 px-3 text-sm text-shades-900`,
]

export const flowEditorTextareaCss = [
  flowEditorFieldBorderCss,
  tw`min-h-0 min-w-0 flex-1 resize-y bg-shades-0 px-3 py-2.5 font-[inherit] text-sm leading-normal text-shades-900`,
]

export const flowEditorTextInputPaddedCss = [
  flowEditorFieldBorderCss,
  tw`min-w-0 flex-1 bg-shades-0 px-3 py-2.5 text-sm text-shades-900`,
]

export const flowEditorTextInputSmCss = [
  flowEditorFieldBorderCss,
  tw`h-10 min-w-0 flex-1 bg-shades-0 px-3 text-sm text-shades-900`,
]
